import React, { Component } from 'react';
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import PromotionMiddleware from "../../store/prat_middleware/gt/promotionMiddleware";
import ProductMiddleware from "../../store/prat_middleware/gt/productMiddleware";
import GeoMiddleware from '../../store/prat_middleware/gt/geoMiddleware';
import PreAndPostOpsoMiddleware from "../../store/prat_middleware/preAndPostOpso/preAndPostOpsoMiddleware";
import ChannelMiddleware from "../../store/prat_middleware/gt/channelMiddleware";
import DATA from '../../assets/data';
import Button from '@material-ui/core/Button';
import PreAndPostOpsoTable from './preAndPostOpsoTable';
import { Loader } from "../../components/loader";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import {compare} from '../gt/validation/sort';
import './preAndPostOpso.styles.scss';

class PreAndPostOpso extends Component {
    constructor(props) {
        super(props);
        this.state = {
            division: "",
            category: "",
            selectedPromotionType: "",
            selectedPromotionLevel: "",
            selectedProductDivisions: [],
            selectedProductCategories: '',
            selectedProductSkus: [],
            selectedProductMasterSkus: [],
            selectedProductBrands: [],
            promotionType: [],
            promotionLevelType: "",
            myBrands: [],
            mySkus: [],
            myMasterSkus: [],
            selectedProductVariants: [],
            selectedProductFormats: [],
            selectedYear: '',
            selectedWeekFrom: '',
            selectedWeekTo: '',
            selectedMonth: [],
            startingWeeks: [],
            selectedGeoRegions: [],
            selectedChannel: [],
            selectedMasterChannel: [],
            selectedElements: [],
            selectedSubElement: [],
            myChannel: [],
            myElement: [],
            mySubElement: [],
            downloadDropDownOpen: false,

        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.props.get_AllPromotionType()
            this.props.get_productDevisions();
            this.props.get_productCategories();
            this.props.get_productBrands();
            this.props.get_productMasterSkus();
            this.props.get_regions();
            this.props.get_channel();
            this.props.get_masterChannel();
            this.props.get_elements();
            this.props.get_subElements();

            // Getting data on component mount
            this.props.getPreAndPostOpso(
                this.state.selectedProductDivisions,
                this.state.selectedProductCategories,
                this.state.selectedProductBrands,
                this.state.selectedProductMasterSkus,
                this.state.selectedProductFormats,
                this.state.selectedYear,
                this.state.selectedMonth,
                this.state.selectedWeekFrom,
                this.state.selectedWeekTo,
                this.state.selectedPromotionType,
                this.state.selectedGeoRegions,
                this.state.selectedMasterChannel,
                this.state.selectedChannel,
                this.state.selectedElements,
                this.state.selectedSubElement
            )
        }, 1000)
    }

    handleDivision = (selectedValue) => {
        let arr = [];
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({ selectedProductDivisions: [] })
        } else {
            selectedValue.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedProductDivisions: arr });
        }
    }

    handleCategory = category => {
        console.log(category)
        if (category === null || category === '') {
            this.setState({
                selectedProductCategories: '', selectedProductBrands: [], selectedProductMasterSkus: [], selectedProductSkus: [], myBrands: [], myMasterSkus: [],
                selectedProductFormats: []
            })
        } else {
            this.setState({ selectedProductCategories: category.value }, () => {
                this.handleFilteredBrands();
            });
        }
    };

    handleFilteredBrands = () => {
        const {
            selectedProductCategories,
            myBrands,
            selectedProductBrands
        } = this.state;
        const { product_brands } = this.props;
        let filteredbrands = [];
        if (selectedProductCategories) {
            for (let i = 0; i < 1; i++) {
                filteredbrands.push(
                    ...product_brands.filter(item => {
                        return item.Category === selectedProductCategories;
                    })
                );
            }
            this.setState({
                myBrands: filteredbrands
            });
            let arr = [];
            if (selectedProductBrands.length !== 0) {
                myBrands.forEach(element => {
                    selectedProductBrands.forEach((e, i) => {
                        if (element.guid === e) {
                            arr.push(e);
                            this.setState({ selectedProductBrands: arr });
                        } else {
                        }
                    });
                });
            }
        }
    };

    handleBrandChange = selectedBrand => {
        let arr = [];
        if (selectedBrand === null || selectedBrand.length === 0) {
            this.setState({ selectedProductBrands: [], selectedProductMasterSkus: [], selectedProductSkus: [], myMasterSkus: [], selectedProductFormats: [] })
        } else {
            selectedBrand.forEach(e => {
                arr.push(e.value);
            });
            this.setState({ selectedProductBrands: arr }, () => {
                this.handleFilteredMasterSku();
            });
        }
    };

    handleFilteredMasterSku = () => {
        const {
            selectedProductBrands,
            selectedProductMasterSkus,
            myMasterSkus
        } = this.state;
        const { product_master_skus } = this.props;
        let filteredSkus = [];
        if (selectedProductBrands.length) {
            for (let i = 0; i < selectedProductBrands.length; i++) {
                filteredSkus.push(
                    ...product_master_skus.filter(item => {
                        return item.Brand === selectedProductBrands[i];
                    })
                );
            }
            this.setState({
                myMasterSkus: filteredSkus
            });
            let selectedSkuFinal = [];
            if (selectedProductMasterSkus.length !== 0) {
                myMasterSkus.forEach(element => {
                    selectedProductMasterSkus.forEach((e, i) => {
                        if (element.guid === e) {
                            selectedSkuFinal.push(e);
                            this.setState({ selectedProductMasterSkus: selectedSkuFinal });
                        } else {
                        }
                    });
                });
            }
        }
    };

    handleMasterSkusChange = selectedMasterSku => {
        let arr = [];
        if (selectedMasterSku === null || selectedMasterSku.length === 0) {
            this.setState({ selectedProductMasterSkus: [], selectedProductSkus: [], selectedProductFormats: [] })
        } else {
            selectedMasterSku.forEach(e => {
                arr.push(e.value);
            });
            this.setState({ selectedProductMasterSkus: arr });
        }
    };

    handleFormatsChange = selectedFormat => {
        if (selectedFormat === null || selectedFormat.length === 0) {
            this.setState({ selectedProductFormats: [] })
        }
        if (selectedFormat) {
            let arr = [];
            selectedFormat.forEach(element => {
                arr.push(element.value);
            });
            this.setState({
                selectedProductFormats: arr
            });
        }
    };

    format_focusie = () => {
        if (this.state.selectedProductMasterSkus.length) {
            let data = {
                level: 'master_skus',
                _ids: this.state.selectedProductMasterSkus
            }
            this.props.get_productFormats(data);
        } else if (this.state.selectedProductBrands.length) {
            let data = {
                level: 'brands',
                _ids: this.state.selectedProductBrands
            }
            this.props.get_productFormats(data);
        } else if (this.state.selectedProductCategories.length) {
            let data = {
                level: 'categories',
                _ids: this.state.selectedProductCategories
            }
            this.props.get_productFormats(data);
        }
        else if (!this.state.selectedProductCategories.length && !this.state.selectedProductBrands.length && !this.state.selectedProductMasterSkus.length) {
            let data = {
                level: '',
                _ids: []
            }
            this.props.get_productFormats(data);
        }
    }

    handleYearChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({
                selectedYear: selectedValue.value,
            });
        }
        else {
            this.setState({
                selectedYear: "",
            });
        }
    }

    handleMonthChange = (selectedValue) => {
        let arr = [];
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({ selectedMonth: [], selectedWeekFrom: '', selectedWeekTo: '', startingWeeks: [] })
        }
        else {
            selectedValue.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedMonth: arr, selectedWeekFrom: '', selectedWeekTo: '' }, () => {
                this.handleFilterWeekFrom()
            });
        }
    }

    handleFilterWeekFrom = () => {
        let arr = []
        this.state.selectedMonth.forEach(item => {
            DATA.WEEK_NO.forEach(elm => {
                if (item === elm.JC_Month) {
                    arr.push(elm)
                }
            })
        })
        this.setState({ startingWeeks: arr })
    }

    handleWeekFromChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({
                selectedWeekFrom: selectedValue.value,
            });
        } else {
            this.setState({
                selectedWeekFrom: "",
                selectedWeekTo: ""
            });
        }
    }

    handleWeekToChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({
                selectedWeekTo: selectedValue.value,
            });
        } else {
            this.setState({
                selectedWeekTo: "",
            });
        }
    }

    handlePromotionType = selectedValue => {
        if (selectedValue) {
            this.setState({
                selectedPromotionType: selectedValue.value,
            });
        } else {
            this.setState({
                selectedPromotionType: "",
            });
        }
    };

    handleRegionChange = (selectedRegions) => {
        if (selectedRegions == null || selectedRegions.length === 0) {
            this.setState({ selectedGeoRegions: [] })
        }
        else {
            let arr = [];
            selectedRegions.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedGeoRegions: arr })
        }
    }

    handleMasterChannelChange = (selectedMasterChannel) => {
        let arr = [];
        if (selectedMasterChannel == null || selectedMasterChannel.length === 0) {
            this.setState({ selectedMasterChannel: [], myChannel: [], myElement: [], mySubElement: [], selectedChannel: [], selectedElement: [], selectedSubElement: [] })
        }
        if (selectedMasterChannel) {
            selectedMasterChannel.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedMasterChannel: arr }, () => {
                this.handleFilteredChannel()
            })
        }
    }

    handleFilteredChannel() {
        const {
            selectedMasterChannel,
            selectedChannel,
            myChannel
        } = this.state;
        const { channel } = this.props;
        let filteredChannel = [];
        if (selectedMasterChannel.length !== 0 && channel) {

            for (let i = 0; i < selectedMasterChannel.length; i++) {
                filteredChannel.push(
                    ...channel.filter(item => {
                        return item.MasterChannel === selectedMasterChannel[i];
                    })
                );
            }
            let selectedChannelFinal = [];
            myChannel.forEach(element => {
                if (selectedChannel.length !== 0) {
                    selectedChannel.forEach(e => {
                        if (element.guid === e) {
                            selectedChannelFinal.push(e);
                            this.setState({
                                selectedChannel: selectedChannelFinal
                            });
                        }
                    });
                }
            });
            this.setState({
                myChannel: filteredChannel
            });
        }
    }

    handleChannelChange = (selectedChannel) => {
        let arr = [];
        if (selectedChannel == null || selectedChannel.length === 0) {
            this.setState({ selectedChannel: [], selectedElement: [], selectedSubElement: [], myElement: [], mySubElement: [] })
        }
        if (selectedChannel) {
            selectedChannel.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedChannel: arr }, () => {
                this.handleFilteredElement()
            })
        }
    }

    handleFilteredElement() {
        const {
            selectedChannel,
            selectedElement,
            myElement
        } = this.state;
        const { element } = this.props;
        let filteredElement = [];
        if (selectedChannel.length !== 0 && element) {
            for (let i = 0; i < selectedChannel.length; i++) {
                filteredElement.push(
                    ...element.filter(item => {
                        return item.Channel === selectedChannel[i];
                    })
                );
            }
            let selectedTownFinal = [];
            myElement.forEach(element => {
                if (selectedElement.length !== 0) {
                    selectedElement.forEach(e => {
                        if (element.guid === e) {
                            selectedTownFinal.push(e);
                            this.setState({
                                selectedElement: selectedTownFinal
                            });
                        }
                    });
                }
            });
            this.setState({
                myElement: filteredElement
            });
        }
    }

    handleElementChange = (selectedElement) => {
        let arr = [];
        if (selectedElement == null || selectedElement.length === 0) {
            this.setState({ selectedElement: [], selectedSubElement: [], mySubElement: [] })
        }
        if (selectedElement) {
            selectedElement.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedElement: arr }, () => {
                this.handleFilteredSubElement()
            })
        }
    }

    handleFilteredSubElement() {
        const {
            selectedElement,
            selectedSubElement,
            mySubElement
        } = this.state;
        const { sub_element } = this.props;
        let filteredSubElement = [];
        if (selectedElement.length !== 0 && sub_element) {
            for (let i = 0; i < selectedElement.length; i++) {
                filteredSubElement.push(
                    ...sub_element.filter(item => {
                        return item.Element === selectedElement[i];
                    })
                );
            }
            let selectedSubElementFinal = [];
            mySubElement.forEach(element => {
                if (selectedSubElement.length !== 0) {
                    selectedSubElement.forEach(e => {
                        if (element.guid === e) {
                            selectedSubElementFinal.push(e);
                            this.setState({
                                selectedSubElement: selectedSubElementFinal
                            });
                        }
                    });
                }
            });
            this.setState({
                mySubElement: filteredSubElement
            });
        }
    }

    handleSubElementChange = (selectedSubElement) => {
        let arr = [];
        if (selectedSubElement == null || selectedSubElement.length === 0) {
            this.setState({ selectedSubElement: [] })
        } if (selectedSubElement) {
            selectedSubElement.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedSubElement: arr })
        }

    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.getPreAndPostOpso(
            this.state.selectedProductDivisions,
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus,
            this.state.selectedProductFormats,
            this.state.selectedYear,
            this.state.selectedMonth,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedPromotionType,
            this.state.selectedGeoRegions,
            this.state.selectedMasterChannel,
            this.state.selectedChannel,
            this.state.selectedElements,
            this.state.selectedSubElement
        )
    }

    handleDownloadPrePostOpso = () => {
        this.setState({
            downloadDropDownOpen: false
        })
        this.props.downloadPreVsPostOpso(
            2,
            this.state.selectedProductDivisions,
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus,
            this.state.selectedProductFormats,
            this.state.selectedYear,
            this.state.selectedMonth,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedPromotionType,
            this.state.selectedGeoRegions,
            this.state.selectedMasterChannel,
            this.state.selectedChannel,
            this.state.selectedElements,
            this.state.selectedSubElement
        )
    }

    handleDownloadPrePostOpsoTotalCut = () => {
        this.setState({
            downloadDropDownOpen: false
        })
        this.props.downloadPreVsPostOpso(
            1,
            this.state.selectedProductDivisions,
            this.state.selectedProductCategories,
            this.state.selectedProductBrands,
            this.state.selectedProductMasterSkus,
            this.state.selectedProductFormats,
            this.state.selectedYear,
            this.state.selectedMonth,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedPromotionType,
            this.state.selectedGeoRegions,
            this.state.selectedMasterChannel,
            this.state.selectedChannel,
            this.state.selectedElements,
            this.state.selectedSubElement
        )
    }

    render() {
        return (
            <div className="page-container">

                {this.props.isPreAndPostOpsoLoading ? <Loader flag={true} /> : null}

                <div className="heading-and-download-container">

                    <span className='component-heading'>Pre vs Post OPSO Report</span>

                    <div style={{ width: '26px', height: '31px', position: 'relative' }}>

                        {this.props.isFileDownloading ?

                            <img style={{ width: '100%', height: '100%' }} src={require('../../assets/gifs/Downloading.gif')} alt='' />
                            :

                            <img style={{ cursor: 'pointer' }} src={require('../../assets/images/downloadIcon.svg')}
                                onClick={() => { this.setState({ downloadDropDownOpen: !this.state.downloadDropDownOpen }) }} alt='' />}

                        {
                            this.state.downloadDropDownOpen ?
                                    // Download Dropdown
                                <ClickAwayListener onClickAway={() => { this.setState({ downloadDropDownOpen: false }) }}>

                                    <div className='download-dropdown'>

                                        <span className='download-label-container' onClick={this.handleDownloadPrePostOpsoTotalCut}>

                                            <img src={require('../../assets/images/downloadArrow.svg')} alt='' />

                                            <label className='download-label'>Pre vs Post OPSO Total cut</label>

                                        </span>

                                        <span className='download-label-container' onClick={this.handleDownloadPrePostOpso}>

                                            <img src={require('../../assets/images/downloadArrow.svg')} alt='' />

                                            <label className='download-label'>Post OPSO (Region & Channel cut)</label>

                                        </span>

                                    </div>

                                </ClickAwayListener>

                                :
                                null
                        }

                    </div>
                </div>

                <div className='select-download-container'>

                    <div className="select-container">

                        <div className='filters-container-only'>

                            <CustomSelect.MyCustomSelect
                                className='select-box'
                                placeholder="Divisions"
                                allowSelectAll={false}
                                isMulti
                                options={
                                    this.props.product_divisions
                                        ? this.props.product_divisions.map(item => ({
                                            value: item.guid,
                                            label: item.Name
                                        }))
                                        : []
                                }
                                value={
                                    this.props.product_divisions
                                        ? this.props.product_divisions
                                            .filter(item => {
                                                return !this.state.selectedProductDivisions
                                                    ? void 0
                                                    : this.state.selectedProductDivisions.includes(item.guid);
                                            })
                                            .map(item => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Name
                                                };
                                            })
                                        : null
                                }
                                onChange={this.handleDivision}
                            />

                            <CustomSelect.MyCustomSelect
                                className='select-box'
                                placeholder={"Category"}
                                allowSelectAll={false}
                                isMulti={false}
                                isClearable
                                options={
                                    this.props.product_categories
                                        ? !this.props.product_categories
                                            ? void 0
                                            : this.props.product_categories.sort(compare).map(item => ({
                                                value: item.guid,
                                                label: item.Name
                                            }))
                                        : []
                                }
                                onChange={this.handleCategory}
                                value={
                                    this.props.product_categories
                                        ? this.props.product_categories
                                            .filter(item => {
                                                return !this.state.selectedProductCategories
                                                    ? void 0
                                                    : this.state.selectedProductCategories === item.guid;
                                            })
                                            .map(item => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Name
                                                };
                                            }) : void 0
                                }
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder={"Brand"}
                                allowSelectAll={true}
                                isMulti
                                options={
                                    this.state.myBrands
                                        ? this.state.myBrands.sort(compare).map(item => ({
                                            value: item.guid,
                                            label: item.Name
                                        }))
                                        : void 0
                                }
                                onChange={this.handleBrandChange}
                                value={
                                    this.state.myBrands
                                        ? this.state.myBrands
                                            .filter(item => {
                                                return this.state.selectedProductBrands.includes(item.guid);
                                            })
                                            .map(item => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Name
                                                };
                                            })
                                        : null
                                }
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder={"Master SKU"}
                                allowSelectAll={true}
                                isMulti
                                options={
                                    this.state.myMasterSkus
                                        ? this.state.myMasterSkus.sort(compare).map(item => ({
                                            value: item.guid,
                                            label: item.Description
                                        }))
                                        : void 0

                                }
                                onChange={this.handleMasterSkusChange}
                                value={
                                    this.state.myMasterSkus
                                        ? this.state.myMasterSkus
                                            .filter(item => {
                                                return this.state.selectedProductMasterSkus.includes(item.guid);
                                            })
                                            .map(item => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Description
                                                };
                                            })
                                        : null
                                }
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder={"Format"}
                                allowSelectAll={true}
                                isMulti
                                onFocus={this.format_focusie}
                                onBlur={this.props.product_formats && this.onBlur}
                                options={
                                    this.props.product_formats
                                        ? this.props.product_formats.sort(compare).map(item => ({
                                            value: item.guid,
                                            label: item.Name
                                        }))
                                        : []
                                }
                                onChange={this.handleFormatsChange}
                                value={
                                    this.props.product_formats
                                        ? this.props.product_formats
                                            .filter(item => {
                                                return !this.state.selectedProductFormats
                                                    ? void 0
                                                    : this.state.selectedProductFormats.includes(item.guid);
                                            })
                                            .map(item => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Name
                                                };
                                            })
                                        : null
                                }
                            />

                            <CustomSelect.MyCustomSelect
                                className="select-box"
                                placeholder={"Year"}
                                isClearable={true}
                                options={DATA.YEARSPreVsPostOpso.map((item) => ({
                                    value: item.value,
                                    label: item.label,
                                }))}
                                onChange={this.handleYearChange}
                                value={DATA.YEARSPreVsPostOpso
                                    ? DATA.YEARSPreVsPostOpso
                                        .filter(item => {       // eslint-disable-line
                                            if (item.value === this.state.selectedYear) {
                                                return item
                                            }
                                        })
                                        .map(item => {
                                            return {
                                                value: item.value,
                                                label: item.label
                                            };
                                        }) : void 0}
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder={"Month"}
                                allowSelectAll={true}
                                isMulti
                                options={DATA.QUARTER_MONTHS.map((item) => ({
                                    value: item.value,
                                    label: item.name
                                }))}
                                onChange={this.handleMonthChange}
                                value={DATA.QUARTER_MONTHS
                                    ? DATA.QUARTER_MONTHS
                                        .filter(item => {
                                            return this.state.selectedMonth.includes(item.value);
                                        })
                                        .map(item => {
                                            return {
                                                value: item.value,
                                                label: item.name
                                            };
                                        }) : void 0}
                            />

                            <CustomSelect.MyCustomSelect
                                className="select-box"
                                placeholder="Week From"
                                isClearable={true}
                                options={
                                    this.state.startingWeeks
                                        ? this.state.startingWeeks.map(item => ({
                                            value: item.value,
                                            label: item.label
                                        }))
                                        : void 0
                                }
                                onChange={this.handleWeekFromChange}
                                value={this.state.startingWeeks
                                    ? this.state.startingWeeks
                                        .filter(item => {
                                            return !this.state.selectedWeekFrom
                                                ? void 0
                                                : item.value === this.state.selectedWeekFrom;
                                        })
                                        .map(item => {
                                            return {
                                                value: item.value,
                                                label: item.label
                                            };
                                        })
                                    : void 0
                                }
                            />

                            <CustomSelect.MyCustomSelect
                                className="select-box"
                                placeholder="Week To"
                                isClearable={true}
                                options={this.state.selectedWeekFrom ? this.state.startingWeeks.filter(item => {
                                    return (
                                        item.value >= this.state.selectedWeekFrom
                                    )
                                }).map((item) => ({
                                    value: item.value,
                                    label: item.label,
                                })) : []}
                                onChange={this.handleWeekToChange}
                                value={DATA.WEEK_NO
                                    ? DATA.WEEK_NO
                                        .filter(item => {
                                            return !this.state.selectedWeekTo
                                                ? void 0
                                                : item.value === this.state.selectedWeekTo;
                                        })
                                        .map(item => {
                                            return {
                                                value: item.value,
                                                label: item.label
                                            };
                                        })
                                    : void 0
                                }
                            />

                            <CustomSelect.MyCustomSelect
                                className='select-box promotion_type placeholder-font-size'
                                placeholder="Promotion Type"
                                isClearable={true}
                                options={
                                    this.props.promotion_types
                                        ? this.props.promotion_types.map(item => ({
                                            value: item.guid,
                                            label: item.Label
                                        }))
                                        : []
                                }
                                value={this.props.promotion_types
                                    ? this.props.promotion_types
                                        .filter(item => {
                                            return !this.state.selectedPromotionType
                                                ? void 0
                                                : item.guid === this.state.selectedPromotionType;
                                        })
                                        .map(item => {
                                            return {
                                                value: item.guid,
                                                label: item.Label
                                            };
                                        })
                                    : void 0
                                }
                                onChange={this.handlePromotionType}
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder={"Region"}
                                allowSelectAll={true}
                                isMulti
                                options={
                                    this.props.geo_regions
                                        ? this.props.geo_regions.sort(compare).map(item => ({
                                            value: item.guid,
                                            label: item.Name
                                        }))
                                        : []
                                }
                                value={
                                    this.props.geo_regions
                                        ? this.props.geo_regions
                                            .filter(item => {
                                                return !this.state.selectedGeoRegions ? void 0 : this.state.selectedGeoRegions.includes(
                                                    item.guid
                                                );
                                            })
                                            .map(item => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Name
                                                };
                                            })
                                        : null}
                                onChange={this.handleRegionChange}
                            />

                            <CustomSelect.MyCustomSelect
                                className='placeholder-font-size'
                                placeholder={"Master Channel"}
                                allowSelectAll={true}
                                isMulti
                                options={
                                    this.props.master_channel
                                        ? this.props.master_channel.map(item => ({
                                            value: item.guid,
                                            label: item.Name
                                        }))
                                        : []
                                }
                                value={
                                    this.props.master_channel
                                        ? this.props.master_channel
                                            .filter(item => {
                                                return !this.state.selectedMasterChannel ? void 0 : this.state.selectedMasterChannel.includes(
                                                    item.guid
                                                );
                                            })
                                            .map(item => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Name
                                                };
                                            })
                                        : []
                                }
                                onChange={this.handleMasterChannelChange}
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder={"Channel"}
                                allowSelectAll={true}
                                isMulti
                                options={
                                    this.state.myChannel
                                        ? this.state.myChannel.sort(compare).map(item => ({
                                            value: item.guid,
                                            label: item.Name
                                        }))
                                        : []
                                }
                                value={this.state.myChannel
                                    ? this.state.myChannel
                                        .filter(item => {
                                            return !this.state.selectedChannel ? void 0 : this.state.selectedChannel.includes(
                                                item.guid
                                            );
                                        })
                                        .map(item => {
                                            return {
                                                value: item.guid,
                                                label: item.Name
                                            };
                                        })
                                    : null}
                                onChange={this.handleChannelChange}
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder={"Element"}
                                allowSelectAll={true}
                                isMulti
                                options={
                                    this.state.myElement
                                        ? this.state.myElement.sort(compare).map(item => ({
                                            value: item.guid,
                                            label: item.Name
                                        }))
                                        : []
                                }
                                value={
                                    this.state.myElement
                                        ? this.state.myElement
                                            .filter(item => {
                                                return !this.state.selectedElement ? void 0 : this.state.selectedElement.includes(
                                                    item.guid
                                                );
                                            })
                                            .map(item => {
                                                return {
                                                    value: item.guid,
                                                    label: item.Name
                                                };
                                            })
                                        : null}
                                onChange={this.handleElementChange}
                            />

                            <CustomSelect.MyCustomSelect
                                className='placeholder-font-size-sub-element'
                                placeholder={"Sub-Element"}
                                allowSelectAll={true}
                                isMulti
                                options={
                                    this.state.mySubElement
                                        ? this.state.mySubElement.sort(compare).map(item => ({
                                            value: item.guid,
                                            label: item.Name
                                        }))
                                        : []
                                }
                                value={this.state.mySubElement
                                    ? this.state.mySubElement
                                        .filter(item => {
                                            return !this.state.selectedSubElement ? void 0 : this.state.selectedSubElement.includes(
                                                item.guid
                                            );
                                        })
                                        .map(item => {
                                            return {
                                                value: item.guid,
                                                label: item.Name
                                            };
                                        })
                                    : null}
                                onChange={this.handleSubElementChange}
                            />

                        </div>

                        <Button
                            style={{ marginBottom: '16px', width: '136px' }}
                            variant="outlined"
                            className="submit-btn"
                            onClick={(e) => this.handleSubmit(e)}
                        >
                            SUBMIT
                    </Button>

                    </div>

                </div>
                {/* Absolute Spend Component */}
                <PreAndPostOpsoTable preAndPostOpso={this.props.preAndPostOpso ? this.props.preAndPostOpso.Absolute : []} heading='absolute' />
                {/* Count Activities Component */}
                <PreAndPostOpsoTable preAndPostOpso={this.props.preAndPostOpso ? this.props.preAndPostOpso.Count : []} heading='count' />

            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        promotion_types: state.PromotionReducer.promotionType,
        promotion_level: state.PromotionReducer.promotionLevel,
        product_divisions: state.ProductReducer.productDevisions,
        product_categories: state.ProductReducer.productCategories,
        product_brands: state.ProductReducer.productBrands,
        product_master_skus: state.ProductReducer.productMasterSkus,
        product_formats: state.ProductReducer.producFormats,
        geo_regions: state.GeoReducer.geoRegions,
        channel: state.GtChannelReducer.channel,
        master_channel: state.GtChannelReducer.masterChannel,
        element: state.GtChannelReducer.element,
        sub_element: state.GtChannelReducer.subElement,
        preAndPostOpso: state.PreAndPostOpsoReducer.preAndPostOpso,
        isPreAndPostOpsoLoading: state.PreAndPostOpsoReducer.isPreAndPostOpsoLoading,
        isFileDownloading: state.DownloadXlxReducer.isFileDownloading,

    };
};

const mapDispatchToProps = dispatch => {
    return {
        get_AllPromotionType: () => {
            return dispatch(PromotionMiddleware.get_AllPromotionType());
        },
        get_productDevisions: () => {
            return dispatch(ProductMiddleware.get_devisions());
        },
        get_productCategories: () => {
            return dispatch(ProductMiddleware.get_categories());
        },
        get_productBrands: () => {
            return dispatch(ProductMiddleware.get_brands());
        },
        get_productSkus: () => {
            return dispatch(ProductMiddleware.get_skus());
        },
        get_productMasterSkus: () => {
            return dispatch(ProductMiddleware.get_master_skus());
        },
        get_productVariants: () => {
            return dispatch(ProductMiddleware.get_variants());
        },
        get_productFormats: (data) => {
            return dispatch(ProductMiddleware.get_formats(data));
        },
        get_regions: () => {
            return dispatch(GeoMiddleware.get_regions())
        },
        get_masterChannel: () => {
            return dispatch(ChannelMiddleware.get_masterChannel());
        },
        get_channel: () => {
            return dispatch(ChannelMiddleware.get_channel());
        },
        get_elements: () => {
            return dispatch(ChannelMiddleware.get_elements());
        },
        get_subElements: () => {
            return dispatch(ChannelMiddleware.get_subElements());
        },
        getPreAndPostOpso: (
            selectedProductDivisions,
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus,
            selectedProductFormats,
            selectedYear,
            selectedMonth,
            selectedWeekFrom,
            selectedWeekTo,
            selectedPromotionType,
            selectedGeoRegions,
            selectedMasterChannel,
            selectedChannel,
            selectedElements,
            selectedSubElement
        ) => {
            return dispatch(PreAndPostOpsoMiddleware.getPreAndPostOpso(
                selectedProductDivisions,
                selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus,
                selectedProductFormats,
                selectedYear,
                selectedMonth,
                selectedWeekFrom,
                selectedWeekTo,
                selectedPromotionType,
                selectedGeoRegions,
                selectedMasterChannel,
                selectedChannel,
                selectedElements,
                selectedSubElement
            ))
        },
        downloadPreVsPostOpso: (
            fileType,
            selectedProductDivisions,
            selectedProductCategories,
            selectedProductBrands,
            selectedProductMasterSkus,
            selectedProductFormats,
            selectedYear,
            selectedMonth,
            selectedWeekFrom,
            selectedWeekTo,
            selectedPromotionType,
            selectedGeoRegions,
            selectedMasterChannel,
            selectedChannel,
            selectedElements,
            selectedSubElement
        ) => {
            return dispatch(PreAndPostOpsoMiddleware.downloadPreVsPostOpso(
                fileType,
                selectedProductDivisions,
                selectedProductCategories,
                selectedProductBrands,
                selectedProductMasterSkus,
                selectedProductFormats,
                selectedYear,
                selectedMonth,
                selectedWeekFrom,
                selectedWeekTo,
                selectedPromotionType,
                selectedGeoRegions,
                selectedMasterChannel,
                selectedChannel,
                selectedElements,
                selectedSubElement
            ))
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PreAndPostOpso);
